import { FormattedMessage } from 'react-intl';

import { Icon } from '../../../../../common/icon';
import { IconTypes, IconSizes } from '../../../../../common/icon/icon.models';
import { useStyles } from './pickup-point-info.styles';
import { DeliveryInformation, IStore } from '../../../../../../graphql/order/models/get-orders.models';

interface PickupPointInfoProps {
  deliveryInformation?: DeliveryInformation | null;
  store?: IStore | null;
}

export const PickupPointInfo = ({ deliveryInformation, store }: PickupPointInfoProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} data-testid="pickup-point-info">
      <h3 className={classes.title}><FormattedMessage id="order.delivery.yandex.title" /></h3>
      {deliveryInformation?.address && (
        <div className={classes.row}>
          <Icon type={IconTypes.mapMarkerBlack} size={IconSizes.sm} aria-hidden="true" />
          <span>{deliveryInformation.address}</span>
        </div>
      )}
      {deliveryInformation?.workingHours && (
        <div className={classes.row}>
          <Icon type={IconTypes.deliveryClockIcon} size={IconSizes.sm} aria-hidden="true" />
          <span>{deliveryInformation.workingHours}</span>
        </div>
      )}
      {(deliveryInformation?.pickupPointId || store?.displayName) && (
        <p className={classes.row}>
          <Icon type={IconTypes.deliveryShoppingBag} size={IconSizes.sm} aria-hidden="true" />
          <span>
            <FormattedMessage id="order.delivery.yandex.partner" />
            {store?.displayName && ` «${store.displayName}»`}
          </span>
        </p>
      )}
    </div>
  );
};
